import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@rabex-kit/rabex-ui';
import { emailRegex } from '../../components/Login';
import RegisterForm from '../../components/Register';
import { useRegisterMutation } from '../../services/auth';
import { RegisterRequestBody } from '../../services/auth/types';
import TokenManager from '../../utils/tokenManager';
import * as routes from '../../pages/routes';
import { returnPathFrom } from '@/utils/loginReturn';
import handleSubmitError from '../../utils/authErrors';
import { OTP_DESCRIPTION, OTP_TITLE } from '@/constants/authOtp';

const RegisterContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [registerRequest, { isLoading, isSuccess }] = useRegisterMutation();
  const params = useParams();
  const referralCode = params.referralCode || '';

  const handleOnSubmit = (values: RegisterRequestBody) => {
    registerRequest(values)
      .unwrap()
      .then((res) => {
        const isEmail = emailRegex.test(values.phone.trim());
        // Only a pre-OTP token: held in memory until the code is verified (containers/Otp).
        TokenManager.setPending(res.data.accessToken);
        navigate(routes.OTP, {
          state: {
            title: isEmail ? OTP_TITLE.email : OTP_TITLE.sms,
            description: isEmail ? OTP_DESCRIPTION.email : OTP_DESCRIPTION.sms,
            highlight: isEmail
              ? values.phone
              : values.phone.replace(
                  /(\d{4})(\d{3})(\d{2})(\d{2})/g,
                  '$1 $2 $3 $4'
                ),
            from: 'register',
            type: isEmail ? 'email' : 'sms',
            returnTo: returnPathFrom(location.state)
          }
        });
      })
      .catch(handleSubmitError);
  };

  return (
    <Stack flexDirection="row" gap={17.5}>
      <RegisterForm
        onSubmit={handleOnSubmit}
        isLoading={isLoading || isSuccess}
        initialReferralCode={referralCode}
      />
    </Stack>
  );
};

export default RegisterContainer;
